import React, { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Listing from "../../Masters/listing";

import { notifyError, notifySuccess } from "../../../../helpers/Notify";
import { Formik } from "formik";

import { useDeleteModelMutation } from "../../../../features/Inventory/model/modelApiSlice";
import {
  useCreateParentServiceMutation,
  useGetParentServicesQuery,
  useDeleteParentServiceMutation
} from "../../../../features/parentService/parentServiceApiSlice";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../../features/auth/authSlice";

const validateSchema = yup.object().shape({
  parentServiceName: yup
    .string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters")
    .max(100, "Name must be less than 100 characters"),
});

export default function ParentService() {
  const userInfo = useSelector(selectCurrentUser);
  const [createParentService , {isLoading}] = useCreateParentServiceMutation();
  const { data, error, refetch } = useGetParentServicesQuery();
  
  const [deleteParent] = useDeleteParentServiceMutation();
  const handleDelete = async (id) => {
    const result = await deleteParent(id);
    refetch();
    notifySuccess(result?.data?.message);
  };

  const [search, setSearch] = useState("");

  const filterModels = () => {
    if (!search) return data?.services;

    return data?.services?.filter((service) => {
      const name = service?.parentServiceName?.toLowerCase();
      const date = new Date(service?.createdAt).toLocaleString().toLowerCase();

      return (
        name.includes(search.toLowerCase()) ||
        date.includes(search.toLowerCase())
      );
    });
  };

  const filteredModels = filterModels();

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const result = await createParentService(values);

      refetch();
      notifySuccess(result?.data?.message);
      resetForm(); // Reset form values after successful submission
    } catch (error) {
      notifyError(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Add Parent Service</h4>

              <div>
                <input
                  type="text"
                  name="search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search"
                  className="form-control"
                />
              </div>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <div className="row">
                  <div className="col-md-6">
                    <Formik
                      initialValues={{ parentServiceName: "" }}
                      enableReinitialize={true}
                      validationSchema={validateSchema}
                      onSubmit={handleSubmit}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <div className={`form-group mb-3`}>
                            <label className="text-label">
                              Add Parent Service
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name"
                              name="parentServiceName"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.parentServiceName}
                              disabled={
                                !userInfo?.Role?.permissions?.includes(
                                  "parent-services/create"
                                )
                              }
                            />

                            <div
                              id="val-username1-error"
                              className="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.parentServiceName &&
                                errors.parentServiceName}
                            </div>
                          </div>
                          <div className="text-right">
                          <button
                            type="submit"
                            className="btn btn-primary me-2"
                            disabled={isLoading}
                          >
                            {isLoading ? (
                              <>
                                <div
                                  className="spinner-border text-light"
                                  role="status"
                                ></div>
                              </>
                            ) : (
                              "Submit"
                            )}
                          </button>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </div>
                  <div className="col-md-6">
                    <Listing
                      isCheck={"parent service"}
                      data={filteredModels}
                      handleDelete={handleDelete}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
